import PageLayout, { PageCTA } from '../components/PageLayout';
import { IMAGES } from '../mock';
import { useLang } from '../i18n/LanguageContext';

export default function MerchandisePage() {
  const { t } = useLang();
  const p = t('pages.merchandise');
  const cats = t('platform.productCategories');
  return (
    <PageLayout crumb={p.breadcrumb} title={p.hero} subtitle={p.sub} heroImage={IMAGES.warehouse}>
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy text-center mb-4">{p.catalog}</h2>
          <p className="text-gray-600 text-center max-w-2xl mx-auto mb-12">{p.note}</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {cats.map((c, i) => (
              <div key={i} className="p-5 bg-gray-50 rounded-xl border border-gray-100 hover-lift hover:border-brand-yellow hover:bg-white">
                <div className="text-brand-yellow font-bold text-xs mb-2">{String(i + 1).padStart(2, '0')}</div>
                <div className="font-semibold text-brand-navy">{c}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <PageCTA title={p.ctaTitle} body={p.ctaBody} />
    </PageLayout>
  );
}
